import type { Config } from "./types";

export const config: Config = {
    audienceId: 0,
    columns: [],
    filters: [],
    id: 0,
    languageId: 0,
    search: {
        label: "Search",
        minChars: 3,
        placeholder: "Search...",
        searchOn: ["name", "ticker", "isin"],
    },
    tabs: [],
    url: "",
};

export default config;
